package com.patronat.top.client.presentation.onboarding

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.OnboardingDescriptionText
import com.patronat.top.ui.theme.OnboardingTitleText
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun OnboardingPageContent(
    page: OnboardingPage,
    pageCount: Int,
    activePage: Int,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(
            painter = painterResource(page.image),
            contentDescription = null,
            contentScale = ContentScale.Crop,
            modifier = Modifier
                .fillMaxWidth()
                .height(357.dp)
                .clip(RoundedCornerShape(12.dp))
        )

        Spacer(modifier = Modifier.height(26.dp))

        OnboardingIndicator(
            pageCount = pageCount,
            activePage = activePage
        )

        Spacer(modifier = Modifier.height(26.dp))

        Text(
            text = stringResource(page.title),
            style = OnboardingTitleText,
            modifier = Modifier.widthIn(max = 300.dp)
        )

        Spacer(modifier = Modifier.height(12.dp))

        Text(
            text = stringResource(page.description),
            style = OnboardingDescriptionText,
            modifier = Modifier.widthIn(max = 300.dp),
            maxLines = 3
        )

        Spacer(modifier = Modifier.weight(1f))
    }
}
